import { StrictMode } from 'react';

import { initTelemetry } from '@/lib/telemetry';
import { createRoot } from 'react-dom/client';

import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/geist-mono/400.css';
import '@fontsource/geist-mono/700.css';
import '@/styles/globals.css';
import '@/i18n/i18n';
import '@/features/table/consts/agGridModules';

import { Providers } from '@/providers/Providers';

initTelemetry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers />
  </StrictMode>
);
